export default __webpack_public_path__ + "static/media/icon-hazard.f2a42e42.svg";